import React from 'react';
import { Chip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface ApiKeyStatusChipProps {
  isActive: boolean;
  expiresAt?: string | null;
}

const ApiKeyStatusChip: React.FC<ApiKeyStatusChipProps> = ({ isActive, expiresAt }) => {
  const { t } = useTranslation();

  // Check if expired
  const isExpired = expiresAt && new Date(expiresAt) < new Date();

  if (isExpired) {
    return <Chip label={t('f-slaughterhouse-api-key-expired')} color="secondary" size="small" />;
  }

  if (isActive) {
    return <Chip label={t('f-slaughterhouse-api-key-active')} color="primary" size="small" />;
  }

  return <Chip label={t('f-slaughterhouse-api-key-inactive')} color="default" size="small" />;
};

export default ApiKeyStatusChip;
